import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import '../styles/Cabecera.css';

import logo from '../imagenes/icons/bicentenario_rojo.png';

function Cabecera() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };
  const handleLinkClick = () => {
    setMenuOpen(false);
    setOpenDropdown(null);
  };
    
  return(
    <div className='navbar'>
      <div className='logo'>
        <img src={logo}></img> 
        <span>Municipalidad Provincial de Chumbivilcas</span>
      </div>
      <button className='menu-toggle' onClick={() => setMenuOpen(!menuOpen)}>
        ☰ 
      </button>
      <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
        <Link to='/' onClick={handleLinkClick}>Inicio</Link>
        <div className='dropdown'>
          <button className='dropbtn' onClick={() => toggleDropdown('municipalidad')}>Municipalidad ▾</button>
          <div className={`dropdown-content ${openDropdown === 'municipalidad' ? 'show' : ''}`}>
            <Link to='/Concejo' onClick={handleLinkClick}>Concejo Municipal</Link>
            <Link to='/Comisiones' onClick={handleLinkClick}>Comisiones Fiscalizadoras</Link>
            <Link to='/Organigrama' onClick={handleLinkClick}>Organigrama</Link>
            <Link to='/Coprosec' onClick={handleLinkClick}>COPROSEC</Link>
            <Link to='/Instrumentos' onClick={handleLinkClick}>Instrumentos de Gestión</Link>
          </div>
        </div>
        
        {/*<div className='dropdown'>
          <button className='dropbtn' onClick={() => toggleDropdown('gerencias')}>Gerencias ▾</button>
          <div className={`dropdown-content ${openDropdown === 'gerencias' ? 'show' : ''}`}>
            <Link to='/' onClick={handleLinkClick}>Gerencia Municipal</Link>
            <Link to='/' onClick={handleLinkClick}>Gerencia de Administración Tributaria</Link>
            <Link to='/' onClick={handleLinkClick}>Gerencia de Desarrollo Económico</Link>
            <Link to='/' onClick={handleLinkClick}>Gerencia de Desarrollo Territorial e Infraestructura</Link>
            <Link to='/' onClick={handleLinkClick}>Gerencia de Servicios Municipales y Gestión Ambiental</Link>
            <Link to='/' onClick={handleLinkClick}>Gerencia de Desarrollo Social</Link>
          </div>
        </div>*/}

        <div className='dropdown'>
          <button className='dropbtn' onClick={() => toggleDropdown('convocatorias')}>Convocatorias ▾</button>
          <div className={`dropdown-content ${openDropdown === 'convocatorias' ? 'show' : ''}`}>
            <Link to='/Convocatorias' onClick={handleLinkClick}>Convocatorias CAS</Link>
            <Link to='/Nombramientos' onClick={handleLinkClick}>Convocatorias Nombramientos</Link>
          </div>
        </div>
        <Link to='/Certificados' onClick={handleLinkClick}>Consultar Certificado</Link>
        <Link to='/Concursos' onClick={handleLinkClick}>Concursos 2025</Link>
        {/*<Link to='/Rendiciones' onClick={handleLinkClick}>Rendiciones</Link>*/}
        <a href='https://sgd.munichumbivilcas.gob.pe/tramite_externo.php' target='_blank'>Mesa de Partes</a>
        <div className='dropdown'>
          <button className='dropbtn' onClick={() => toggleDropdown('enlaces')}>Enlaces de Interes ▾</button>
          <div className={`dropdown-content ${openDropdown === 'enlaces' ? 'show' : ''}`}>
            <Link to='/Atractivos-Turisticos' onClick={handleLinkClick}>Atractivos turisticos</Link>
            <a href='https://www.gob.pe/institucion/munichumbivilcas/normas-legales/tipos/89-resolucion-de-alcaldia' target='_blank'>Resolución de Alcaldia</a>
            <a href='https://www.gob.pe/institucion/munichumbivilcas/normas-legales/tipos/108-acuerdo-de-concejo' target='_blank'>Acuerdos de Concejo Municipal</a>
            <a href='https://www.gob.pe/institucion/munichumbivilcas/normas-legales/tipos/159-resolucion-de-gerencia-municipal' target='_blank'>Resoluciones de Gerencia Municipal</a>
            <a href='https://www.gob.pe/institucion/munichumbivilcas/normas-legales/tipos/130-resolucion-de-administracion' target='_blank'>Resoluciones de Administración</a>
            <a href='https://www.gob.pe/institucion/munichumbivilcas/normas-legales/tipos/111-ordenanza-municipal' target='_blank'>Ordenanzas Municipales</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cabecera;

    
